import React from "react";
import { Link } from "react-router-dom";
import { Utensils } from "lucide-react";

const PublicFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-sky-500 rounded-xl flex items-center justify-center">
                <Utensils className="w-5 h-5 text-white" />
              </div>
              <div>
                <span className="font-bold text-lg">Dalabsom</span>
              </div>
            </div>
            <p className="text-gray-400 text-sm max-w-md">
              The leading QR ordering platform for restaurants in Somalia. 
              Accept mobile money payments (EVC Plus, Zaad, E-Dahab), manage orders in real-time, and grow your business with Dalabsom.
            </p>
            <div className="mt-4 flex items-center gap-2 text-sm text-gray-400">
              <span className="w-2 h-2 bg-sky-500 rounded-full"></span>
              <span>Proudly serving Somalia</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="/#how-it-works" className="text-gray-400 hover:text-white text-sm transition-colors">
                  How It Works
                </a>
              </li>
              <li>
                <a href="/#features" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Features
                </a>
              </li>
              <li>
                <a href="/#pricing" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Pricing
                </a>
              </li>
              <li>
                <Link to="/demo" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Demo
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <a href="/terms" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="/privacy" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="mailto:hello@dalabsom.com" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-400 text-sm">
            © {currentYear} Dalabsom. All rights reserved.
          </p>
          <p className="text-gray-500 text-xs">
            Made with ❤️ in Mogadishu, Somalia
          </p>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
